"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
// All Rev colors with unique identifiers
exports.colors = {
    /* Brand Colors */
    violet: '#2E1A69',
    chartreuse: '#DFFF00',
    /* Neutrals */
    white: '#FFFFFF',
    black: '#000000',
    /* Light scales */
    light: {
        background: '#F7F7F8',
        'background-secondary': '#ECF0F1',
        'background-tertiary': '#FCFBF7',
        'background-quaternary': '#FAFAFE',
        /*System Colors */
        success: '#168104',
        'success-bg': '#D1FFCA',
        error: '#CD261D',
        'error-bg': '#FFBFBC',
        warning: '#DBB220',
        'warning-bg': '#FFF2C6',
        'divider-extra-light': '#EBEBEB',
        'divider-dark': '#888',
        divider: '#B7B7B7',
        /* Gray Scale */
        gray: {
            10: '#F7F7F8',
            20: '#dFE0E1',
            30: '#C5C6C8',
            40: '#A6A8Ab',
            50: '#8B8D8F',
            60: '#6E6F71',
            70: '#515253',
            80: '#38393A',
            90: '#262627',
            92: '#EBEBEB',
            95: '#ECF0F1',
            100: '#161616',
        },
        /* Neutral Scale */
        neutral: {
            10: '#FAF6EF',
            20: '#EDDFBE',
            30: '#D5C59C',
            40: '#B5A784',
            50: '#988C6E ',
            60: '#786E56',
            70: '#59523F',
            80: '#3E392B',
            90: '#2A261C',
            100: '#18160F',
        },
        /* Supporting Colors */
        green: {
            20: '#168104',
        },
        orange: {
            10: '#FFF4F2',
            20: '#FFD7CF',
            30: '#FFB4A1',
            40: '#FF8758',
            50: '#E96502',
            60: '#B94F01',
            70: '#8B3901',
            80: '#632700',
            90: '#451900',
            100: '#2F2C13',
        },
        yellow: {
            10: '#FBF9EC',
            20: '#F3EDB7',
            30: '#F1E57C',
            40: '#EAD257',
            50: '#E8C71F',
            60: '#E1C21D',
            70: '#C2B110',
            80: '#9C8F1B',
            90: '#645B0F',
            100: '#2F2C13',
        },
        teal: {
            10: '#F0F7F4',
            20: '#D2E8E0',
            30: '#B4D9CC',
            40: '#9ACDBC',
            50: '#7FC2AC',
            60: '#62B89D',
            70: '#4B977F',
            80: '#367C66',
            90: '#225644',
            100: '#083324',
        },
        lilac: {
            10: '#E4E2EE',
            20: '#D2D0E5',
            30: '#C2BEDB',
            40: '#9593C3',
            50: '#7978B3',
            60: '#5F61A6',
            70: '#4C4B84',
            80: '#414065',
            90: '#323147',
            100: '#20202A',
        },
        pink: {
            10: '#FFF4F6',
            20: '#FFD6DF',
            30: '#FFB1C3',
            40: '#FF7FA3',
            50: '#FF4085',
            60: '#DA0067',
            70: '#A4004C',
            80: '#760034',
            90: '#530023',
            100: '#350014',
        },
        cyan: {
            10: '#E8FAFC',
            20: '#B0EBEF',
            30: '#70D5DD',
            40: '#0CBAC2',
            50: '#089CA3',
            60: '#057B81',
            70: '#035C60',
            80: '#014043',
            90: '#012B2E',
            100: '#00191B',
        },
        red: {
            50: '#CD261D',
            70: '#861913',
        },
        blue: {
            10: '#F4F6FF',
            20: '#D9DFFF',
            30: '#B7C3FF',
            40: '#8DA3FF',
            50: '#5F86FF',
            60: '#0064F7',
            70: '#004ABB',
            80: '#003387',
            90: '#00225F',
            100: '#00133D',
        },
        'new-blue-gray': {
            13: '#1B1F26',
            61: '#8095B7',
            93: '#E1EAF9',
            88: '#CDDBF3',
            97: '#F6F8FB',
        },
        purple: {
            10: '#F6F5FF',
            20: '#E0DDFE',
            30: '#C7BFFD',
            40: '#A99CFC',
            50: '#8F7AFB',
            60: '#724EF9',
            70: '#5614EB',
            80: '#3C0BAA',
            90: '#280579',
            100: '#17024F',
        },
        violet: {
            10: '#E0DDFE',
            20: '#C7BFFD',
            30: '#8D57FF',
            50: '#5614EB',
            60: '#3F00FF',
            70: '#3C0BAA',
            80: '#2E1A69',
        },
    },
    /* Dark scales */
    dark: {
        background: '#18181B',
        /*System Colors */
        success: '#127203',
        'success-bg': '#063000',
        error: '#CD261D',
        'error-bg': '#4E0400',
        warning: '#BC8D3F',
        'warning-bg': '#452B00',
        /* Gray Scale */
        gray: {
            10: '#0B0B0B',
            20: '#1D1D1E',
            30: '#303131',
            40: '#48494A',
            '40-new': '#656667',
            50: '#606263',
            60: '#7E7F81',
            70: '#9C9EA0',
            80: '#BABCBD',
            90: '#D3D4D5',
            92: '#EBEBEB',
            100: '#EAEAEB',
        },
        /* Neutral Scale */
        neutral: {
            10: '#0D0B06',
            20: '#201D14',
            30: '#353024',
            40: '#4F4938',
            50: '#6A614B',
            60: '#897E63',
            70: '#AA9D7C',
            80: '#CABA93',
            90: '#E4D3A7',
            100: '#F3EAD6',
        },
        /* Supporting Colors */
        orange: {
            10: '#1A0500',
            20: '#371200',
            30: '#562000',
            40: '#7D3301',
            50: '#A44501',
            60: '#D35B02',
            70: '#F27D4F',
            80: '#FFA58B',
            90: '#FFC7BA',
            100: '#FFE5DF',
        },
        yellow: {
            10: '#232008',
            20: '#413B09',
            30: '#665D0F',
            40: '#8F820C',
            50: '#AF9614',
            60: '#D7B91F',
            70: '#E1CA53',
            80: '#E4D976',
            90: '#ECE4A3',
            100: '#FBF9EC',
        },
        teal: {
            10: '#021811',
            20: '#072D1F',
            30: '#124535',
            40: '#207157',
            50: '#389275',
            60: '#64B499',
            70: '#8BCBB6',
            80: '#AAD7C7',
            90: '#D2E8E0',
            100: '#F0F7F4',
        },
        lilac: {
            10: '#1C1C27',
            20: '#2C2B42',
            30: '#353458',
            40: '#3F3E7A',
            50: '#4D4F95',
            60: '#6362A5',
            70: '#7C7AB2',
            80: '#9C95C6',
            90: '#CCC9E6',
            100: '#E4E2EE',
        },
        pink: {
            10: '#200009',
            20: '#42001A',
            30: '#66002C',
            40: '#940044',
            50: '#C1005A',
            60: '#F80076',
            70: '#FF6C98',
            80: '#FFA0B8',
            90: '#FFC5D2',
            100: '#FFE3E9',
        },
        cyan: {
            10: '#000D0F',
            20: '#002123',
            30: '#01373A',
            40: '#025256',
            50: '#046D72',
            60: '#068D93',
            70: '#46ACB3',
            80: '#7BC7CD',
            90: '#9DDFE4',
            100: '#CEF1F4',
        },
        red: {
            50: '#CD261D',
            70: '#861913',
        },
        blue: {
            10: '#000926',
            20: '#00194C',
            30: '#002B75',
            40: '#0042A8',
            50: '#0058DB',
            60: '#3F76FF',
            70: '#8199F7',
            80: '#ACB8F7',
            90: '#CAD2FB',
            100: '#E6E9FF',
        },
        purple: {
            10: '#0C0133',
            20: '#1F0362',
            30: '#330894',
            40: '#4D11D4',
            50: '#6535F8',
            60: '#8167FA',
            70: '#9F8FFC',
            80: '#BCB3FD',
            90: '#D4CFFE',
            100: '#EBE8FE',
        },
    },
};
exports.default = exports.colors;
